import DepositAccountSettings from '@/models/Accounts/DepositAccounts/Settings/DepositAccountSettings';
import DepositAccountValues from '@/models/Accounts/DepositAccounts/Values/DepositAccountValues';
import EntityIdentifier from "@/models/Shared/EntityIdentifier";
import ProductMigrationState from '@/models/Products/ProductMigrations/ProductMigrationState';
import DepositAccountPaymentInterface from "@/models/Accounts/DepositAccounts/DepositAccountPaymentInterface";
import AccountState from "@/models/Accounts/Shared/AccountState";
import Wallet from "@/models/Accounts/DepositAccounts/Wallets/Wallet";
import ProductType from "@/models/Products/ProductType";
import ProductSubType from '@/models/Products/ProductSubType';

export default class DepositAccount {
    accountSettings: DepositAccountSettings;
    accountStateReasonCode: string;
    accountStateReasonDescription: string;
    accountValues: DepositAccountValues;
    //availableBalance: Object;
    //balance: Object;
    createdAt: string;
    currentTestDateUtc: Date;
    customerId: string;
    customerIdentifier: EntityIdentifier;
    defaultCurrency: string;
    defaultWalletId: string;
    enabled: boolean;
    id: string;
    inboundOverrideTransactionReference: string;
    lastSuccessfulMigrationId: string;
    lastSuccessfulMigrationIdentifier: EntityIdentifier;
    migrationStatus: ProductMigrationState;
    name: string;
    nextMigrationId: string;
    nextMigrationIdentifier: EntityIdentifier;
    outboundOverrideTransactionReference: string;
    paymentInterfaces: DepositAccountPaymentInterface[] = [];
    productId: string;
    productIdentifier: EntityIdentifier
    productIssueId: string;
    productIssueIdentifier: EntityIdentifier
    productSubType: ProductSubType;
    productType: ProductType;
    reviewDateUtc: Date;
    state: AccountState;
    updatedAt: string;
    wallets: Wallet[] = [];
}